import { makeAutoObservable } from "mobx";
import type { RootStore } from "./root.store";
import {
  getVisibleWorkspaceSettingsTabs,
  hasAnyWorkspacePermission,
  type IWorkspaceSettingsTab,
  type TWorkspaceSettingsTabKey,
} from "@/lib/permissions/workspace-permissions";

export class WorkspaceSettingsStore {
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as never, { autoBind: true });
  }

  get visibleTabs(): IWorkspaceSettingsTab[] {
    // The flag predicate is passed rather than defaulted, because the default fails
    // closed — a flagged tab is invisible until somebody hands the check a real
    // answer, and this store is the only place that has one.
    return getVisibleWorkspaceSettingsTabs(this.rootStore.workspace.currentWorkspace, (key) =>
      this.rootStore.featureFlags.isEnabled(key, false),
    );
  }

  get firstAccessibleTab(): IWorkspaceSettingsTab | undefined {
    return this.visibleTabs[0];
  }

  canAccess(tabKey: TWorkspaceSettingsTabKey): boolean {
    const tab = this.visibleTabs.find((item) => item.key === tabKey);
    return Boolean(tab);
  }

  canAccessAnyPermissions(permissions: IWorkspaceSettingsTab["required"]): boolean {
    return hasAnyWorkspacePermission(this.rootStore.workspace.currentWorkspace, permissions);
  }
}
